// extracted by mini-css-extract-plugin
module.exports = {"wrv7vmg":"wrv7vmg","b8ou0aw":"b8ou0aw","m22xqkj":"m22xqkj","bwtfw5o":"bwtfw5o"};